import { ApiService }             from '../../app-lite/api/api.service';
import { CustomerModel }             from '../../app-lite/customers/models/customer';
import { InvoiceItemModel }          from '../../app-lite/invoices/models/invoice.item';
import { InvoiceModel }              from '../../app-lite/invoices/models/invoice';
import { SessionService }         from '../../app-lite/sessions/session.service';
import { Table }                     from '../../app-lite/table/types/table';
import { TableTextControlComponent } from '../../app-lite/table/cell-components/controls/text-control/table-text-control.component';

import CustomerSearchResultsHtml    from '../../app-lite/customers/templates/customers.search.results.html';

interface SplitInvoiceScope extends ng.IScope {
  clearCustomer                   : () => void;
  currency                        : any;
  customer                        : CustomerModel;
  customerSearch                  : any;
  customerSearchResultsTemplateUrl: string;
  excessAmount                    : number;
  invoice                         : InvoiceModel;
  handleRowClick                  : ( item : InvoiceItemModel ) => void;
  items                           : Array<any>;
  resetItems                      : () => void;
  split                           : () => void;
  tableSettings                   : Table;
}

export function SplitInvoiceCtrl (
  $scope           : SplitInvoiceScope,
  $translate       : ng.translate.ITranslateService,
  $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
  confirm          : any,
  invoice          : InvoiceModel,
  sessionObjAPI    : SessionService,
  streamSearch     : any,
  workshopAPI      : ApiService
) {
  $scope.currency                         = sessionObjAPI.currency();
  $scope.customer                         = null;
  $scope.customerSearchResultsTemplateUrl = CustomerSearchResultsHtml;
  $scope.excessAmount                     = 0;
  $scope.invoice                          = invoice;
  $scope.items                            = invoice.invoice_items_attributes;

  $scope.customerSearch = {
    list    : [],
    selected: {
      display_name: '',
      id          : null
    },
    choose: ( customer : CustomerModel ) => {
      $scope.customer = customer;
    },
    format: ( customer : CustomerModel ) => customer ? customer.display_name: '',
    search: ( typed : string ) => streamSearch.search('customers', typed)
    .then(( customers : Array<CustomerModel> ) => $scope.customerSearch.list.concat(customers))
  };

  $scope.tableSettings = {
    columns: [
      {
        classes: 'Uppercase',
        field  : 'item_code',
        header : {
          text: $translate.instant('PRODUCT_SPACE.PRODUCT')
        }
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        classes: 'text-right',
        field  : 'unit_price',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.UNIT_PRICE')
        },
        pipe: 'globalCurrency'
      },
      {
        classes: 'text-right',
        field  : 'quantity',
        header : {
          classes: 'text-right',
          text   : $translate.instant('PRODUCT_SPACE.QTY')
        },
        pipe: 'number'
      },
      {
        classes  : 'text-right',
        component: {
          bindings: {
            inputs: {
              model: 'split_quantity',
              name : 'split_quantity'
            }
          },
          enabled: true,
          factory: TableTextControlComponent
        },
        header: {
          classes: 'text-right',
          text   : $translate.instant('PRODUCT_SPACE.SPLIT_QTY')
        }
      },
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_ITEMS_FOUND')
    },
    static: true
  };

  $scope.clearCustomer = function () {
    $scope.customer = null;
  };

  $scope.resetItems = function () {
    angular.forEach($scope.items, ( item : any ) => {
      item.split_quantity = 0;
    });
  };

  $scope.split = function () {
    var splitItems = [];

    if (!$scope.customer || !$scope.customer.id) {
      return confirm.custom({
        message: $translate.instant('INVOICE_SPACE.SELECT_VALID_CUSTOMER'),
        type   : 'warning'
      });
    }

    angular.forEach($scope.items, ( item : any ) => {
      if (item.split_quantity) {
        splitItems.push({
          id      : item.id,
          quantity: parseFloat(item.split_quantity)
        });
      }
    });

    if (!splitItems.length) {
      return confirm.custom({
        message: $translate.instant('INVOICE_SPACE.NO_SELECTED_ITEMS_TO_SPLIT'),
        type   : 'warning'
      });
    }

    workshopAPI.post('invoice/split_invoice', {
      customer_id  : $scope.customer.id,
      excess_amount: $scope.excessAmount || 0,
      invoice_id   : invoice.id,
      split_items  : splitItems
    })
    .then(data => {
      data.customer_id = $scope.customer.id;
      data.vehicle_id  = $scope.invoice.vehicle_id;

      $uibModalInstance.close(data);
    })
    .catch(err => {
      $uibModalInstance.dismiss(err);
    });
  };

  $scope.resetItems();
}